var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkStats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 18.9999V22.4285M15.0004 18.9999C16.5159 18.9999 17.9693 18.3979 19.041 17.3262C20.1126 16.2545 20.7147 14.8011 20.7147 13.2856M15.0004 18.9999C13.4849 18.9999 12.0314 18.3979 10.9598 17.3262C9.88817 16.2545 9.28613 14.8011 9.28613 13.2856M20.7147 13.2856C20.7147 11.7701 20.1126 10.3166 19.041 9.24497C17.9693 8.17333 16.5159 7.57129 15.0004 7.57129C13.4849 7.57129 12.0314 8.17333 10.9598 9.24497C9.88817 10.3166 9.28613 11.7701 9.28613 13.2856M20.7147 13.2856H9.28613M9.28613 22.4285H20.7147",
    stroke: "white",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 18.9999C18.4285 15.0913 18.4285 11.2741 14.9999 7.57129C11.6399 11.137 11.5713 14.9313 14.9999 18.9999Z",
    stroke: "white",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkStats);
export default __webpack_public_path__ + "static/media/Network Stats.41a972e31d9255d8b983d3419d685f93.svg";
export { ForwardRef as ReactComponent };